<template>
  <v-row>
    <v-col>
    <h1>Промокоды</h1>
      <v-tabs v-model="tab">
        <v-tab>Генератор</v-tab>
        <v-tab>Использованные</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item><promocode-index></promocode-index></v-tab-item>
        <v-tab-item><promocode-codes></promocode-codes></v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
  // @ is an alias to /src

  import PromocodeIndex from './Index'
  import PromocodeCodes from './Codes'

  export default {
    name: 'PromocodeHome',
    data: () => ({
      tab: '',
    }),
    components: {PromocodeIndex, PromocodeCodes}
  }
</script>
